import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLocale } from '../contexts/LocaleContext';

const PrivacyPolicy: React.FC = () => {
  const { t } = useLocale();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 py-20">
        <h1 className="text-2xl font-semibold mb-4">{t.pages?.privacyPolicy?.title || 'Privacy Policy'}</h1>
        <div className="prose">
          <p>{t.pages?.privacyPolicy?.content || 'Placeholder privacy policy content. Replace with the real text.'}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
